import { HTTP } from "@/http-common";
import { httpError } from "@/models/httpError";
const actions = {
  createFiles() {
    return new Promise((resolve, reject) => {
      HTTP.post("qantas/CreatePointsFile")
        .then((data) => {
          resolve(data.data);
        })
        .catch((err) => {
          reject(err.message);
        });
    });
  },
  sendFiles() {
    return new Promise((resolve, reject) => {
      HTTP.post("qantas/SendFiletoQantas")
        .then((data) => {
          resolve(data.data);
        })
        .catch((err) => {
          reject(err.message);
        });
    });
  },
  PollQBRServer() {
    return new Promise((resolve, reject) => {
      HTTP.post("qantas/PollQantasForHandback")
        .then((data) => {
          resolve(data.data);
        })
        .catch((err) => {
          reject(err.message);
        });
    });
  },
  GetPointsToSend({ dispatch }) {
    return new Promise((resolve, reject) => {
      HTTP.get("qantas/GetPointsToSend")
        .then((data) => {
          resolve(data.data);
        })
        .catch((err) => {
          dispatch(
            "setMessage",
            new httpError({
              message: err.message,
              httpStatus: 500,
            }),
            {
              root: true,
            }
          );
          reject();
        });
    });
  },
  GetPaidCustomers({ dispatch }) {
    return new Promise((resolve, reject) => {
      HTTP.get("qantas/GetQantasPointsPaid")
        .then((data) => {
          resolve(data.data);
        })
        .catch((err) => {
          dispatch(
            "setMessage",
            new httpError({
              message: err.message,
              httpStatus: 500,
            }),
            {
              root: true,
            }
          );
          reject();
        });
    });
  },
  GetSentTransmissions({ dispatch }) {
    return new Promise((resolve, reject) => {
      HTTP.get("qantas/GetSentRecords")
        .then((data) => {
          resolve(data.data);
        })
        .catch((err) => {
          dispatch(
            "setMessage",
            new httpError({
              message: err.message,
              httpStatus: 500,
            }),
            {
              root: true,
            }
          );
          reject();
        });
    });
  },
  GetManageableRecords({ dispatch }) {
    return new Promise((resolve, reject) => {
      HTTP.get("qantas/GetManageableRecords")
        .then((data) => {
          resolve(data.data);
        })
        .catch((err) => {
          dispatch(
            "setMessage",
            new httpError({
              message: err.message,
              httpStatus: 500,
            }),
            {
              root: true,
            }
          );
          reject();
        });
    });
  },
  GetDeletedRecords({ dispatch }) {
    return new Promise((resolve, reject) => {
      HTTP.get("qantas/GetDeletedRecords")
        .then((data) => {
          resolve(data.data);
        })
        .catch((err) => {
          dispatch(
            "setMessage",
            new httpError({
              message: err.message,
              httpStatus: 500,
            }),
            {
              root: true,
            }
          );
          reject();
        });
    });
  },
  SuppressRecords({ dispatch }, records) {
    return new Promise((resolve, reject) => {
      HTTP.post("qantas/SuppressRecords/", records)
        .then((data) => {
          resolve(data.data);
        })
        .catch((err) => {
          dispatch(
            "setMessage",
            new httpError({
              message: err.message,
              httpStatus: 500,
            }),
            {
              root: true,
            }
          );
          reject();
        });
    });
  },
  DeleteRecords({ dispatch }, records) {
    return new Promise((resolve, reject) => {
      HTTP.post("qantas/DeleteRecords", records)
        .then((data) => {
          resolve(data.data);
        })
        .catch((err) => {
          dispatch(
            "setMessage",
            new httpError({
              message: err.message,
              httpStatus: 500,
            }),
            {
              root: true,
            }
          );
          reject();
        });
    });
  },
   GetManualQantasPoints({ dispatch }, query) {
    return new Promise((resolve, reject) => {
      HTTP.post("Commissions/GetManualQantas", query)
        .then((data) => {
          resolve(data.data);
        })
        .catch((err) => {
          dispatch(
            "setMessage",
            new httpError({
              message: err.message,
              httpStatus: 500,
            }),
            {
              root: true,
            }
          );
          reject();
        });
    });
  },
   AddManualQantas({ dispatch }, records) {
    return new Promise((resolve, reject) => {
      HTTP.post("Commissions/AddManualQantas", records)
        .then((data) => {
          resolve(data.data);
        })
        .catch((err) => {
          dispatch(
            "setMessage",
            new httpError({
              message: err.message,
              httpStatus: 500,
            }),
            {
              root: true,
            }
          );
          reject();
        });
    });
  },
   ModifyManualQantas({ dispatch }, records) {
    return new Promise((resolve, reject) => {
      HTTP.post("Commissions/ModifyManualQantas", records)
        .then((data) => {
          resolve(data.data);
        })
        .catch((err) => {
          dispatch(
            "setMessage",
            new httpError({
              message: err.message,
              httpStatus: 500,
            }),
            {
              root: true,
            }
          );
          reject();
        });
    });
  },
   RemoveManualQantas({ dispatch }, records) {
    return new Promise((resolve, reject) => {
      HTTP.post("Commissions/RemoveManualQantas", records)
        .then((data) => {
          resolve(data.data);
        })
        .catch((err) => {
          dispatch(
            "setMessage",
            new httpError({
              message: err.message,
              httpStatus: 500,
            }),
            {
              root: true,
            }
          );
          reject();
        });
    });
  },
};

export default {
  namespaced: true,
  actions,
};
